module.exports = __webpack_public_path__ + "static/media/use-case-11.71dbb61a.jpg";